import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface AmendTransitProps {
  transitId: string;
  name: string;
}

export const useAmendTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, name }: AmendTransitProps): Promise<void> => {
      const result = await apiClient.transit.amendTransit.mutation({ params: { transitId }, body: { name } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit amended!');
    },
    onError: (error) => {
      showErrorToast(error, `Error amending the transit!`);
    },
  });
};
